<template>
    <div class="all">
        <div class="screen">
            <div class="item">
                <h1 class="ac">全文检索</h1>
            </div>
            <div class="item">
                <div class="search-warp big clearfix">
                    <span class="drop-down fl">
                        <button class="btn search-dropdown cp" type="button"><span class="text">全文</span><i class="icons"></i></button>
                        <ul class="option">
							<li @click="searchSelect(0);">全文</li>
                            <li @click="searchSelect(3);">标题</li>
                            <li @click="searchSelect(2);">内容</li>
                            <li @click="searchSelect(1);">来源</li>
                        </ul>
                    </span>
                    <button class="search-btn fr" @click="KeyUpEsc"><i class="icons search-icon"></i></button> 
                    <div class="hidden"><input type="text" v-model.trim="keywords" @keyup.enter="KeyUpEsc" :placeholder="searchPlaceholder[searchSelectVal]" class="input-text"></div>
                </div>
            </div>
            <div class="mt30" v-if="contentShow">
                <div class="item clearfix">
                    <span class="zu clearfix">
                        <span class="d-flex">
                            <span class="name">媒体类别</span>
                            <platTypeCascader title="媒体类别" :industryTypeList="mediaLevelList" :morenzhi="morenzhi" @putData="putData"></platTypeCascader>
                        </span>
                    </span>
                    <span class="zu clearfix">
                        <span class="name">情感属性</span>
                        <span class="drop-down">
                            <button class="btn btn-lightblue">{{emotion === '' ? '全部' : emotion}}<i class="icons"></i></button>
                            <ul class="option">
                                <li v-for="(item,index) in emotionList" @click="dropDownSelect(1,item)" :key="index">{{item}}</li>
                            </ul>
                        </span>
                    </span>
                    <span class="zu clearfix">
                        <span class="name">发布地区</span>
                        <city @cityCallback="citySelect"></city>
                    </span>
                    <span class="zu clearfix">
				        <span class="name">重复信息</span>
				        <span class="drop-down">
				            <button class="btn btn-lightblue"><span class="texts">{{repeatList[collapse]}}</span><i class="icons"></i></button>
				            <ul class="option">
				                <li v-for="(item,index) in repeatList" @click="selectRepeat(index)" :key="index">{{item}}</li>
				            </ul>
				        </span>
				    </span>
                </div>
                <div class="item clearfix">
                    <span class="zu clearfix">
                        <span class="name">时间范围</span>
                        <div class="clearfix fl">
                            <div class="corm fl">
                                <a class="element" :class="{curr:timeType===5}" href="javascript:void(0)" @click="selectFixedTime(5);">24小时</a>
                                <a class="element" :class="{curr:timeType===0}" href="javascript:void(0)" @click="selectFixedTime(0);">今天</a>
                                <a class="element" :class="{curr:timeType===1}" href="javascript:void(0)" @click="selectFixedTime(1);">昨天</a>
                                <a class="element" :class="{curr:timeType===2}" href="javascript:void(0)" @click="selectFixedTime(2);">近三天</a>
                                <a class="element" :class="{curr:timeType===3}" href="javascript:void(0)" @click="selectFixedTime(3);">近七天</a>
                                <a class="element" :class="{curr:timeType===4}" href="javascript:void(0)" @click="selectFixedTime(4);">自定义</a>
                            </div>
                            <vue-datepicker-local v-if="timeType === 4" class="fl" v-model="timeRange" format="YYYY-MM-DD HH:mm:ss" show-buttons :disabledDate="disabledDate"  @confirm="selectedDate"/>
                        </div>
                    </span>
                </div>
                <div class="item mt20 clearfix">
                    <span class="name">媒体类型</span>
                    <div class="screen-list">
                        <label class="checkbox-box" v-for="(item,index) in MediaPlatformList" :key="index">
                            <label class="checkbox-warp fl" :class="platformType.indexOf(index) != -1 ? 'curr' : ''">
                                <input class="checkbox" v-model="platformType" name="" type="checkbox" :value="index">
                                <i class="icons checkbox-icon"></i>
                            </label>
                            {{item.name}} <span class="color-8a8a99">({{item.num}})</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="warp mt20" v-if="contentShow">
            <div class="warp-header">
                <div class="firle clearfix">
                    <div class="fl">
                        <label class="checkbox-box tion">
                            <label class="checkbox-warp fl" :class="uuids.length === pageUuid.length &&  uuids.length > 0 ? 'curr' : ''">
                                <input class="checkbox" name="selectAll" :checked="uuids.length === pageUuid.length && uuids.length > 0 ? true : false"  @click="checkAll($event)" type="checkbox" value="0">
                                <i class="icons checkbox-icon"></i>
                            </label>
                            全选
                        </label>
                        <!-- <span class="checkbox-box tion">删除</span> -->
                        <span class="checkbox-box cp tion" @click="downLoad(1);" title="下载当前所选数据">批量下载</span>
                        <span class="checkbox-box cp tion" @click="downLoad(2);" title="下载当前方案的所有数据">全部下载</span>
                    </div>
                </div>
            </div>
            <!-- 定时查看数据 -->
            <div class="blue-block ac">
                <a class="color-blue" v-if="noUpdateNum > 0" href="javascript:void(0);" @click="updateCurrentData();">{{noUpdateNum}}条新消息，点击查看</a>
                <a class="color-blue" v-if="noUpdateNum <= 0" href="javascript:void(0);" @click="updateCurrentData();">点击刷新</a>
            </div>
            <div class="warp-body clearfix">
                <div class="no-data" v-if="nodata"><img :src="'/static/images/no_data.png'" class="img"/><span class="text">没有数据哦...</span></div>
                <ul class="article-list mtfu24">
                    <li v-for="(item,index) in newsList" :key="index">
                        <div class="article-left fl">
                            <label class="checkbox-warp" :class="uuids.indexOf(item.newsId) != -1 ? 'curr' : ''">
                                <input class="checkbox" v-model="uuids" name="chooseInfo" type="checkbox" :value="item.newsId">
                                <i class="icons checkbox-icon"></i>
                            </label>     
                        </div> 
                        <div class="article-mid qwjs">
                            <router-link class="color-3d3d4c" target="_blank" :to="{path:'/fullTextDetail',query: {id:item.newsId,keywords:keywords}}">
                                <h2 class="article-title ovhidden" :title="item.newsTitle"><span class="tag" :class="$parent.attributeType[item.newsEmotion]">{{item.newsEmotion}}</span><span v-html="item.newsTitle"></span></h2>
                                <p class="ovhidden2 color-8a8a99" :title="item.newsDigest" v-html="item.newsDigest"></p>
                            </router-link>
                            <p class="ziduan color-8a8a99 mt10">
                                <span><a class="color-8a8a99" target="_blank" :href="item.newsUrl">时间：{{item.newsPosttime}}</a></span>
                                <!-- <span>相似文章：<router-link class="color-blue" target="_blank" :to="{path:''+$parent.baseUrl+'/similarArticles',query: {id:item.newsId}}" :class="item.simNum === '' ? 'load-sm' : ''">{{item.simNum}}</router-link></span> -->
                                <span>相似文章：<a class="color-blue" :class="item.simNum === '' ? 'load-sm' : ''" href="javascript:void(0);" @click="jumpSimilar(item.newsId);">{{item.simNum}}</a></span>
                                <span>发布平台：<i class="icons sm-icon" :class="icons[item.platform]"></i>{{item.platformName}}</span>
                                <span>发布人：{{item.mediaName}}</span>
                                <span v-if="item.mediaProvince != ''">发布地区：{{item.mediaProvince}}</span>
                                <span v-if="item.keywords != ''">分析词：<i :class="item.keywords == '' ? 'load-sm' : ''"></i>{{item.keywords}}</span>
                                <!-- <span v-if="item.mediaLevel != ''">媒体等级：{{item.mediaLevel}}</span> -->
                            </p>
                        </div> 
                    </li>
                </ul>
                <!-- 分页 -->
                <page class="mt20" v-if="totalCount != ''" :currentPage.sync="page" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
            </div>
        </div>
        <!-- 下载选项 -->
        <Dialog ref="downloadOption" title="下载字段自定义选择" btnText="下载" :callback="enterOption" type="normal" width="600">
            <div slot="mdBox">
                <h4 v-if="downloadTips != ''">tips:<span class="color-red">{{downloadTips}}</span></h4>
                <div class="checkbox-group nolike clearfix">
                    <label class="checkbox-box">
                        <label class="checkbox-warp fl" :class="selectOptionValue.length === selectOption.length ? 'curr' : ''"><input name="" :checked="selectOptionValue.length === selectOption.length ? true : false" type="checkbox" @click="optionCheckAll($event);" value="" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                        <div class="hidden ac">全选<span class="color-red">（为保证您的下载速度，请尽可能筛选必要的下载字段）</span></div>
                    </label>
                </div>
                <div class="checkbox-group nolike clearfix">
                    <label class="checkbox-box" v-for="(item,index) in selectOption" :key="index">
                        <label class="checkbox-warp fl" :class="selectOptionValue.indexOf(item.type) != -1 ? 'curr' : ''"><input name="" v-model="selectOptionValue" type="checkbox" :value="item.type" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                        <div class="hidden ac">{{item.name}}</div>
                    </label>
                </div>
            </div>
        </Dialog>
	</div>
</template>
<script>
import {mapState} from 'vuex';
import Dialog from '../../components/dialog.vue'
import VueDatepickerLocal from 'vue-datepicker-local'
import platTypeCascader from '../../components/platTypeCascader.vue';
import city from '../../components/city.vue';
import page from '../../components/page.vue';
export default {
    components:{VueDatepickerLocal,city,page,Dialog,platTypeCascader},
    computed:{
        ...mapState({
            mediaLevelList: state => state.show.companyinfo.mediaLevelList
        })
    },
    data() {
        const min = ''
        const max = ''
        return {
            icons:{
                'wx':'wx-icon',
                'web':'web-icon1',
                'weibo':'wb-icon1',
                'app':'app-icon1',
                'bbs':'bbs-icon1',
                'journal':'bk-icon1',
                'media_toutiao':'tt-icon1',
                'media_qq':'qq-icon1',
                'media_baijia':'bj-icon1',
                'media_sohu':'sh-icon1',
                'media_wangyi':'wy-icon1',
                'media_people':'people-icon1'
            },
			contentShow:false,//是否显示搜索结果，默认不显示 搜索后显示
            downloadTips:'',//全部下载提示
            timeRange: [min, max],//时间
			selectOption:[],
            selectOptionValue:['news_title','news_digest','news_author','media_name','news_origin_author_name','media_followers_count','news_url','platform_name','news_emotion','news_content_province','news_posttime','media_province'],//已选择下载
            mediaList:['全部','政府','媒体','个人','其他'],//媒体字段
            emotionList:['全部','正面','中性','负面'],//情感字段 
			searchPlaceholder:['请输入关键词查询','请输入媒体来源查询','请输入信息内容查询','请输入信息标题查询'],//搜索提示语
            MediaPlatformList:[],//媒体类型数组
            repeatList:['不去重','去重'],//相似文章
            collapse:0,//去重type 0是不去重 1是去重
            page:1,//页码
            limit:20,//每页显示条数
            totalCount:'',//总页数
            pageUuid:[],//单分页所有的uuid
            uuids:[],//选择的newsid数组
            planId:'',//方案ID
            mediaLevel:'',//媒体分类
            platformType:['total'],//媒体类型
            startDate:'',//开始时间
            endDate:'',//结束时间
            timeType:0,//时间类型
            searchSelectVal:0,//搜素是的分类
            pubArea:'',//地区
            emotion:'',//情感属性
            keywords:'',//媒体关键词
            newsList:[],//新闻列表
            watch:true,//是否监听
            downLoadType:'',//下载类型
            nodata:false,//暂无数据
            noUpdateNum:0,//未更新条数
            timer:'',//请求定时器
            errorAttribute:'',//纠错属性的值
            errorCorrectionNewsId:'',//纠错的newsId
            morenzhi:{}
            // switchRequest:false//防止多次请求
        }
    },
    mounted() {
        let that = this;
		that.$nextTick(() =>{
            that.selectFixedTime(0,0);
        })
    },
    beforeDestroy() {
        clearInterval(this.timeer);
    },
    created() {
		// 获取缓存方案数据
        this.planId = JSON.parse(sessionStorage.getItem('planStorage')).id;
    },
    methods: {
        //获取选中的方案e
        putData(e){
           //console.log(e)e
            this.mediaLevel = e;
            this.morenzhi = e;
            //数据加载
            //this.endDate_ = this.$utils.getNowDate();
            this.getNewsList(0);
        },
        // 获取当前时间和7天前时间
        initialTime(day) {
            let max = '';
            let min = '';
            let nowTime = this.$utils.getNowDate();
            let n = nowTime.split(' ');
            let n1 = n[0].split('-');
            let n2 = n[1].split(':');
            let oldTime = this.$utils.getBeforeDay(nowTime,day);
            let o = oldTime.split('-');
            max = new Date(n1[0], n1[1]-1, n1[2], n2[0], n2[1], n2[2])
            min = new Date(o[0], o[1]-1, o[2], n2[0], n2[1], n2[2])
            this.timeRange = [min,max];
            //进页面获取时间数据
            this.startDate = this.$utils.dateConversion(min,1);	
            this.endDate = this.$utils.dateConversion(max,1);
        },
        //选择时间回调
        selectedDate () {
            let that = this;
            that.watch = false;
            that.startDate = this.$utils.dateConversion(this.timeRange[0],1);
            that.endDate = this.$utils.dateConversion(this.timeRange[1],1);
            let day = that.$utils.getDateDiff(that.startDate,that.endDate);
            if(day > that.$parent.timeSection){
                that.$utils.alertText('时间跨度最大限制'+that.$parent.timeSection+'天','',1500);
                return;
            }
            //that.getMediaPlatform();
            that.getNewsList(0);
        },
        disabledDate(time){
            let day = this.$parent.timeSection;//获取当前用户的时间范围权限
            let nowTime = this.$utils.getNowDate();//今天时间
            let startDate = this.$utils.getBeforeDay(nowTime,day);//根据时间权限获取最早时间
            let n = nowTime.split(' ');
            startDate = startDate + ' ' + n[1]
            let number = this.$utils.dateToMillisecond(startDate);//将获取的最早时间转化成毫秒
            if(time.getTime() > new Date().getTime() || time.getTime() < number) return true;
            //if(time.getTime() > new Date().getTime()) return true;
        },
        // 固定时间选择
        selectFixedTime (type,apiType) {//0是今天 1是昨天 2是近三天 3是近7天 4是自定义
            let that = this;
            let nowTime = this.$utils.getNowDate();//今天时间
            let n = nowTime.split(' ')[1].split(':');//拆分当前时分秒
            let h = n[0]; 
            let m = n[1]; 
            let s = n[2]; 
            let min = '';
            let max = '';
            that.timeType = type;
            if(type != 4){//非自定义
                if(type === 0){
                    min = nowTime.split(' ')[0] + ' ' + '00:00:00';
                    max = nowTime;
                }else if(type === 1){
                    let yesterday = this.$utils.getBeforeDay(nowTime,1);//前一天
                    min = yesterday + ' ' + '00:00:00';
                    max = yesterday + ' ' + '23:59:59';
                }else if(type === 2){
                    let ptd = this.$utils.getBeforeDay(nowTime,3);//前三天
                    min = ptd + ' ' + '00:00:00';
                    max = nowTime;
                }else if(type === 3){
                    let psd = this.$utils.getBeforeDay(nowTime,7);//前七天
                    min = psd + ' ' + '00:00:00';
                    max = nowTime;
                }else if(type === 5){
                    let psd = this.$utils.getBeforeDay(nowTime,1);//24小时
                    min = psd + ' ' + h + ':' + m + ':' + s;
                    max = nowTime;
                }
                //进页面获取时间数据
                that.startDate = min
                that.endDate = max;
            }else{
                let day = JSON.parse(sessionStorage.getItem('planStorage')).day;
                that.initialTime(day);
            }
			if(apiType === 0){
				return;
			}
            //that.getMediaPlatform();
            that.getNewsList(0);
        },
        // 选择搜索分类
        searchSelect (value) {
            this.searchSelectVal = value;
        },
        // 相似文章去重选择
        selectRepeat (index) {
            this.collapse = index;
            //this.getMediaPlatform();
            this.getNewsList(0);
        },
        //选择城市回调
        citySelect (name) {
            let that = this;
            that.watch = false;
            that.pubArea = name;
            //that.getMediaPlatform();
            that.getNewsList(0);
        },
        // enter键搜索
        KeyUpEsc () {
			if(this.keywords == ''){
				this.$utils.alertText('请输入关键词搜索');
				return;
			}
            this.getNewsList(0);
			//this.getMediaPlatform();
        },
        // 获取新闻列表
        getNewsList (type) {
            let that = this;
            if(that.$parent.showLoad == true){
                return;
            }
            clearInterval(that.timer);//重置定时器
            that.noUpdateNum = 0;
            // that.switchRequest = true;
            if(type === 0){//非翻页
                that.page = 1;
            }
            let datas = {
                page:that.page,
                mediaLevel:that.mediaLevel,
                platformType:that.platformType,
                startDate:that.startDate,
                perpage:that.limit,
                collapse:that.collapse,
                endDate:that.endDate,
                pubArea:that.pubArea,
                emotion:that.emotion,
                searchType:that.searchSelectVal,
                keywords:that.keywords
            };
            that.uuids = [];
            $(".warp .checkbox-warp").removeClass('curr');
            $(".warp input:checkbox[name='selectAll']").prop("checked",false);
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.post('monitor/search/list', {data:datas}, r => {
                that.$utils.returnCode(r,function(){
					that.$parent.showLoad = false;
					if(r.data.isError){//判断违规词
						that.$utils.alertText(r.msg);
					}
                    that.MediaPlatformList = r.data.platformDist;
					that.contentShow = true;
                    let data = r.data;
                    // that.keywords = '';
                    that.newsList = data.list;//新闻列表赋值 
                    that.totalCount = data.total;
                    let pageUuid = [];
                    let simHash = [];
                    let newsId = [];
                    for(let i of data.list){
                        pageUuid.push(i.newsId);
                    }
                    that.pageUuid = pageUuid;
                    if(data.list.length <= 0){//没有数据
                        that.nodata = true;
                        return;
                    }else{
                         that.nodata = false;
                    }
                    // 调用获取关键词和相似文章
                    that.getSimilarArticle(data.list);
                    if(that.timeType != 1 && that.timeType != 4){//昨天和自定义不计未读书
                        that.getNotUpdated();
                    }
                    // that.switchRequest = false;
                });
            })
        },
        // 获取最新未加载的消息
        getNotUpdated () {
            let that = this;
            let datas = {
                page:that.page,
                mediaLevel:that.mediaLevel,
                platformType:that.platformType,
                startDate:that.startDate,
                perpage:that.limit,
                collapse:that.collapse,
                endDate:that.endDate,
                pubArea:that.pubArea,
                emotion:that.emotion,
                searchType:that.searchSelectVal,
                keywords:that.keywords
            };
            that.timer = setInterval(() => {
                that.$api.post('monitor/search/find-new', {data:datas}, r => {
                    that.$utils.returnCode(r,function(){
                        that.noUpdateNum = r.data;
                    })
                })
            }, 300000);
        },
        // 更新当前数据
        updateCurrentData () {
            let that = this;
            that.selectFixedTime(that.timeType);
           // that.getMediaPlatform();
            that.noUpdateNum = 0;
        },
        // 获取关键词和相似文章
        getSimilarArticle (data) {
            let that = this;
            let oldData = data;
            let simHash = [];
            let newsIds = [];
            let postDate = [];
            for(let i of data){
                simHash.push(i.newsSimHash);
                newsIds.push(i.newsId);
                postDate.push(i.newsPostdate);
            }
            let datas = {
                startDate:that.startDate,
				endDate:that.endDate
            };
            that.$api.post('monitor/search/news-simnum', {simHash:simHash,newsId:newsIds,data:datas}, r => {
                that.$utils.returnCode(r,function(){
                    let datas = r.data;
                    for(let i of data){
                        for(let j in datas){
                            if(i.newsId === j){
                                i.simNum = datas[j].simNum;
                            }
                        }
                    }
                    if(that.newsList === oldData){
                        that.newsList = data;
                    }
                });
            })
            that.$api.post('monitor/search/news-keyword', {postDate:postDate,newsId:newsIds,keywords:that.keywords}, r => {
                that.$utils.returnCode(r,function(){
                    let datas = r.data;
                    for(let i of data){
                        for(let j in datas){
                            if(i.newsId === j){
                                i.keywords = datas[j].keywords;
                            }
                        }
                    }
                    if(that.newsList === oldData){
                        that.newsList = data;
                    }
                });
            })
        },
        // 下拉筛选
        dropDownSelect (type,name) {
            let that = this;
            that.watch = false;
            if(type == 0){//媒体类别
                if(name === '全部'){
                    that.mediaLevel = '';
                }else{
                    that.mediaLevel = name;
                }
            }else if(type === 1){//情感属性
                if(name === '全部'){
                    that.emotion = '';
                }else{
                    that.emotion = name;
                }
            }else if(type === 2){//匹配类型
                that.match = name;
            }else if(type === 3){//排序类型
                that.sort = name;
            }
            // if(type === 0 || type === 1){
            //     that.getMediaPlatform();
            // }
            that.getNewsList(0);
            //that.getMediaPlatform();
        },
        // 全选状态
        checkAll (e) {
            let that = this;
            that.uuids = [];
            let checked = e.target.checked;
            if(checked == true){
                that.uuids = that.pageUuid;//全选的时候 获取所有的uuid
            }else{
                that.uuids = [];
            }
        },
        // 下载
        downLoad (type) {
            let that = this;
            that.downLoadType = type;
            that.selectOptionValue = ['news_title','news_digest','news_author','media_name','news_origin_author_name','media_followers_count','news_url','platform_name','news_emotion','news_content_province','news_posttime','media_province'];
            let uuid = '';//全部下载为空
            if(type === 1){//选择下载
                uuid = that.uuids;
                if(uuid.length <= 0){
                    that.$utils.alertText('请选择需要下载的新闻');
                    return;
                }
            }else{
                if(that.newsList.length <= 0){
                    that.$utils.alertText('暂无可下载数据');
                    return;
                }
            }
			let data = {
			    uuid:uuid,
			    mediaLevel:that.mediaLevel,
			    platformType:that.platformType,
			    startDate:that.startDate,
                endDate:that.endDate,
                collapse:that.collapse,
			    field:that.selectOptionValue,
			    pubArea:that.pubArea,
			    searchType:that.searchSelectVal,
			    emotion:that.emotion,
			    keywords:that.keywords
			};
			that.$parent.loadModal(true,'正在获取数据...');
			that.$api.post('monitor/search/download-before', {type:type,data:data}, r => {
			    that.$utils.returnCode(r,function(){
			        that.$parent.showLoad = false;
					that.selectOption = r.data.fieldList;
			        that.downloadTips = r.msg;
			        that.$refs.downloadOption.showMaskFun();
			    });
			})
        },
        // 确定下载字段
        enterOption () {
            let that = this;
            if(that.selectOptionValue.length <= 0){
                that.$utils.alertText('请选择需要下载的字段');
                return;
            }
            let uuid = '';//全部下载为空
            let type = that.downLoadType;
            if(type === 1){//选择下载
                uuid = that.uuids;
            }
            let data = {
                uuid:uuid,
                mediaLevel:that.mediaLevel,
                platformType:that.platformType,
                startDate:that.startDate,
                endDate:that.endDate,
                collapse:that.collapse,
                field:that.selectOptionValue,
                pubArea:that.pubArea,
                searchType:that.searchSelectVal,
                emotion:that.emotion,
                keywords:that.keywords
            };
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post('monitor/search/download', {type:type,data:data}, r => {
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    that.selectOptionValue = [];
                    that.$refs.downloadOption.closeMask();
                    that.$parent.alertTips('已添加到我的下载列表');
                });
            })
        },
        // 下载字段全选
        optionCheckAll (e) {
            let that = this;
            that.selectOptionValue = [];
            let checked = e.target.checked;
            if(checked == true){
                let selectOption = that.selectOption;
                for(let i of selectOption){
                    that.selectOptionValue.push(i.type);
                }
            }else{
                that.selectOptionValue = [];
            }
            
        },
        //确认下载
        // enterDownload () {
            
        // },
        // 翻页
        getTableData () {
            let that = this;
            that.getNewsList(1);
            that.$parent.$refs.child.scrollTop = 0;
        },
		// 跳转相似文章页面
		jumpSimilar (id) {
			let that = this;
			let datas = {
				newsId:id,
			    mediaLevel:that.mediaLevel,
			    platformType:that.platformType,
			    startDate:that.startDate,
                endDate:that.endDate,
                collapse:that.collapse,
			    pubArea:that.pubArea,
			    emotion:that.emotion,
			    searchType:that.searchSelectVal,
			    keywords:that.keywords
			};
			let routeData = that.$router.resolve({
				path: "/fullSimilarArticles",
				query: datas,
			});
			 window.open(routeData.href, '_blank');
		}
    },
    watch: {
        platformType () {
            let that = this;
            let len = that.platformType.length;
            if(that.platformType[0] === 'total' && len > 1){//选择非全部 
                that.platformType.splice(0,1);
            }else if(that.platformType[len-1] === 'total' && len > 1){
                that.platformType = ['total'];
            }
            that.getNewsList(0);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/productCenter/fullTextSearch.vue